<template>
    <div class="brand-page">
        <div class="row no-gutters brands-hero2" id="boss2">
            <div>
                <img src="/images/brand-bgs/brand-logo-bg.png" alt="background">
                <img src="/images/brand-logos/Logo-Boss-Red.png" alt="Boss logo">
            </div>
        </div>

        <div class="brand-content">
            <div>
                <p>
                    Since 1893, Boss® has been THE trusted brand in work gloves. 
                    As the oldest glove company in the United States, we've developed the infrastructure and relationships needed to make sure our customers have the tools and protection to get the job done. 
                    We use our 125+ years of experience to develop and create the best possible work gloves in the industry and will continue to do so for the next 125 years! 
                    We understand that working environments continue to evolve and it is our priority to ensure our products continue to evolve as well. 
                    We consistently strive to innovate and seek unrivaled technologies, materials, and designs to help create the best safety gloves on the market while still providing the comfort and function you have come to expect. 
                    With our innovative culture, be assured we are tirelessly working to bring you the best innovative gloves available. 
                    While we started off creating working gloves for the average farmer, your needs have grown, and you now demand higher quality and more features to take on any task at hand. 
                    This is why we have developed an extensive offering of premium work gloves that can be used for any project you plan to tackle. 
                    Whether you need gloves to use in your garage or backyard, or to work on a farm or construction site, we have the gloves that will keep you safe and performing at your best!
                </p>

                <a href="https://bossgloves.com/" class="btn-round-black" target="_blank">Bossgloves.com</a>
            </div>
        </div>

        <div class="socialspace" style="background-color: rgb(205,27,0);">
            <div>
                <div>
                    <h4>Follow Us</h4>
                    <div>
                        <a href="https://www.facebook.com/BossGloves" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-facebook']"  />
                        </a>
                        <a href="https://www.instagram.com/BossGloves/" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-instagram']" />
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Contact Us</h4>
                    <div class="contact-container">            
                        <div>
                            <a href="mailto:pr@westchestergear.com">
                                <font-awesome-icon :icon="['fas', 'envelope']" />
                            </a>                 
                            <a href="mailto:pr@westchestergear.com">pr@westchestergear.com</a>
                        </div>
                        <div>
                            <a href="tel:518-861-0133">
                                <font-awesome-icon :icon="['fas', 'phone']" />
                            </a>
                            <a href="tel:518-861-0133">(518) 861-0133</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Buy Now</h4>
                    <div>
                        <a href="https://www.amazon.com/stores/BOSS/page/FD2AF217-EAE1-46B2-97C3-DDBDDE4E51B4?ref_=ast_bln" target="_blank" aria-label='Link opens in new window (amazon.com/stores/Boss)'>
                            <img id="amazon-logo" src="/images/amazon-logo-white.svg" alt="amazon logo">
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {};
    },
    methods: {
    }
};
</script>
